// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-renderer-inline[data-v-658a91ae]{white-space:nowrap;overflow:hidden;height:100%;width:100%;max-height:inherit}.media-renderer-inline div[data-v-658a91ae]{height:100%}\n", ""]);
// Exports
module.exports = exports;
